<!-- 
    A set of inputs wrapper to add to a form with  title with a collapsible state and separate title
-->
<script>
  import CustomIcon from "../CustomIcon.svelte";
  export let title = "Some title";
  export let show = true;
  export let boxStyle = "basic";
  const isBasic = boxStyle == "basic"
  $: show = show;
</script>

<div class={isBasic && "border-b-2 border-gray-400"}>
  <div
    class={`flex flex-row px-4 py-3 ${
      !isBasic ? "justify-between sm:flex-row-reverse" : ""
    }`}
  >
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <slot name="expand-button" class="relative">
      <div
      class={`align-middle ${
        isBasic
            ? show? "bg-custom-orange"
            : "bg-white rotate-270 shadow-nv":show? "bg-white rotate-180"
          : "bg-white"
      } flex h-[100%] justify-center rounded-full easy mr-8`}
      on:click={() => {
        show = !show;
      }}
    >
      <CustomIcon
        name="chevron_down"
        width="30"
        height="30"
        color={!isBasic ? "gray" : show ? "white" : "orange"}
      />
    </div>
    </slot>
    <div class="pb-2 pl-1 text-2xl font-bold">
      {title}
    </div>
  </div>
  {#if show}
    <div class="mb-2 p-2">
      <div>
        <slot />
      </div>
    </div>
  {/if}
</div>
